import React, { useState, useCallback, useEffect, useRef } from "react";

const ServicesPage = ({
  coverSrc = "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
  pages = [
    {
      image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      title: "Scientific Conferences",
      content: "Comprehensive support for conference presentations, from abstract preparation to slide design and presentation practice.",
      subtitle: "Presentation Excellence",
      checked: false,
      features: ["Abstract Preparation", "Slide Design", "Presentation Practice", "Q&A Preparation"]
    },
    {
      image: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      title: "Thesis Writing Assistance",
      content: "Comprehensive support for your thesis journey - from proposal to final defense. Our experts guide you through each chapter with detailed feedback.",
      subtitle: "Doctoral & Masters",
      checked: true,
      features: ["Proposal Development", "Chapter-by-Chapter Support", "Formatting", "Defense Preparation"]
    },
    {
      image: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      title: "Research Paper Writing",
      content: "From literature review to results interpretation, we help you craft publishable papers that meet journal standards and contribute to your field.",
      subtitle: "Journal Publications",
      checked: false,
      features: ["Literature Review", "Manuscript Preparation", "Journal Selection", "Revision Support"]
    },
    {
      image: "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      title: "Statistical Analysis",
      content: "Advanced statistical support using SPSS, R, STATA, and other tools. Our statisticians ensure your data is analyzed correctly and presented effectively.",
      subtitle: "Data Processing",
      checked: false,
      features: ["SPSS Analysis", "R Programming", "Data Visualization", "Results Interpretation"]
    },
    {
      image: "https://images.unsplash.com/photo-1589652717521-10c0d092dea9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      title: "Literature Review",
      content: "Thorough literature searches, synthesis of existing research, and identification of research gaps to strengthen your academic work.",
      subtitle: "Comprehensive Research",
      checked: false,
      features: ["Database Searching", "Source Synthesis", "Gap Analysis", "Reference Management"]
    },
    {
      image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      title: "Editing & Proofreading",
      content: "Polishing your academic writing to ensure clarity, coherence, and compliance with style guidelines (APA, MLA, Chicago, etc.).",
      subtitle: "Quality Enhancement",
      checked: false,
      features: ["Grammar Check", "Style Consistency", "Citation Formatting", "Plagiarism Check"]
    },
    {
      image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      title: "Research Proposal Development",
      content: "Expert assistance in crafting compelling research proposals that clearly articulate your research questions, methodology, and expected contributions.",
      subtitle: "Grant Applications",
      checked: false,
      features: ["Problem Statement", "Methodology Design", "Budget Planning", "Grant Writing"]
    },
    {
      image: "https://images.unsplash.com/photo-1591105994050-e1e1e0a9af67?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      title: "Data Visualization",
      content: "Creating compelling visual representations of your data to enhance understanding and impact of your research findings.",
      subtitle: "Visual Communication",
      checked: false,
      features: ["Chart Design", "Infographic Creation", "Dashboard Development", "Interactive Visuals"]
    },
    {
      image: "https://images.unsplash.com/photo-1591105994050-e1e1e0a9af67?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      title: "Publishing Support",
      content: "Expert assistance in preparing your manuscript for publication, including formatting, journal selection, and submission guidance.",
      subtitle: "Academic Publishing",
      checked: false,
      features: ["Manuscript Preparation",
  "Journal Submission Guidance",
  "Peer Review Assistance",
  "Citation Management"]
    }
  ],
  autoFlipDelay = 5000,
  enableAutoFlip = false,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoFlipping, setIsAutoFlipping] = useState(enableAutoFlip);
  const [isPaused, setIsPaused] = useState(false);
  const [viewMode, setViewMode] = useState('cards');
  const [flippedCard, setFlippedCard] = useState(null);
  const [progress, setProgress] = useState(0);
  const progressRef = useRef(null);
  const total = pages.length;

  const next = useCallback(() => {
    setCurrentIndex((c) => {
      const nextIndex = c + 1;
      if (nextIndex >= total && isAutoFlipping) {
        return 0;
      }
      return nextIndex >= total ? 0 : nextIndex;
    });
    setProgress(0);
  }, [total, isAutoFlipping]);

  const prev = useCallback(() => {
    setCurrentIndex((c) => c === 0 ? total - 1 : c - 1);
    setProgress(0);
  }, [total]);

  const toggleAutoFlip = useCallback(() => {
    setIsAutoFlipping(prev => !prev);
    setProgress(0);
  }, []);

  // Auto-flip functionality with progress indicator
  useEffect(() => {
    if (!isAutoFlipping || isPaused) return;
    
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      const newProgress = (elapsedTime / autoFlipDelay) * 100;
      setProgress(Math.min(newProgress, 100));
    }, 50);

    const timeout = setTimeout(() => {
      next();
    }, autoFlipDelay);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [next, autoFlipDelay, isAutoFlipping, isPaused, currentIndex]);

  const goToSlide = useCallback((index) => {
    setCurrentIndex(index);
    setIsPaused(true);
    setTimeout(() => setIsPaused(false), 1000);
  }, []);

  const toggleFlip = useCallback((index) => {
    setFlippedCard(flippedCard === index ? null : index);
  }, [flippedCard]);

  // Cards View (Default)
  if (viewMode === 'cards') {
    return (
      <div className="w-full min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 py-8 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
       

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {pages.map((service, index) => (
              <div 
                key={index}
                className="relative h-64 perspective-1000"
                onClick={() => toggleFlip(index)}
              >
                <div className={`relative w-full h-full duration-700 preserve-3d ${flippedCard === index ? 'rotate-y-180' : ''}`}>
                  {/* Front of Card */}
                  <div className={`absolute inset-0 backface-hidden bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 ${
                    index === currentIndex ? ' ring-blue-500 ring-opacity-50' : ''
                  }`}>
                    {/* Service Image */}
                    <div className="relative h-40 overflow-hidden">
                      <img
                        src={service.image}
                        alt={`${service.title} - AEG Research Thesis Writing Services in Bhopal`}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                      />
                      
                      {/* Status Badge */}
                      <div className="absolute top-4 right-4">
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shadow-lg ${
                          service.checked 
                            ? 'bg-green-500 text-white' 
                            : 'bg-white text-gray-700'
                        }`}>
                          {service.checked ? '✓' : index + 1}
                        </div>
                      </div>

                      {/* Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent flex items-end p-4">
                        <div className="text-white">
                          <p className="text-xs uppercase tracking-wide text-blue-200 mb-1">
                            {service.subtitle}
                          </p>
                          <h3 className="text-lg font-bold line-clamp-1">{service.title}</h3>
                        </div>
                      </div>
                    </div>

                    {/* Service Content */}
                    <div className="p-5">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight line-clamp-2">
                        {service.title}
                      </h3>
                      
                      <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                        {service.content}
                      </p>

                      {/* Flip Hint */}
                      <div className="text-center text-blue-600 text-xs font-medium mt-4">
                        Click to see features →
                      </div>
                    </div>
                  </div>

                  {/* Back of Card */}
                  <div className="absolute inset-0 rotate-y-180 backface-hidden bg-gradient-to-br from-blue-300 to-violet-950 text-black rounded-2xl overflow-hidden shadow-xl p-5">
                    <div className="flex flex-col h-full">
                      <h3 className="text-xl font-bold mb-4">{service.title} Features</h3>
                      
                      <ul className="flex-1 space-y-2 mb-4">
                        {service.features.map((feature, i) => (
                          <li key={i} className="flex items-start">
                            <span className="text-green-300 mr-2">✓</span>
                            <span className="text-sm">{feature}</span>
                          </li>
                        ))}
                      </ul>
                      
                      {/* <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          goToSlide(index);
                        }}
                        className="w-full bg-red-800 text-blue-700 py-2 px-4 rounded-lg font-medium hover:bg-blue-50 transition-all duration-200"
                      >
                        Learn More
                      </button>
                      
                      <div className="text-center text-blue-200 text-xs font-medium mt-3">
                        Click to return
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Controls */}
        
          {/* Empirical Key Statistics */}
          {/* <div className="mt-16 bg-gradient-to-r from-blue-900 via-indigo-900 to-purple-900 rounded-2xl p-8 text-white shadow-xl text-center">
            <h2 className="text-3xl font-extrabold mb-6">Assurance Education Group Impact in Numbers</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm">
                <p className="text-4xl font-extrabold text-blue-300">1,200+</p>
                <p className="text-sm font-medium mt-1 text-gray-200">Thesis Projects Supported</p>
              </div>
              <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm">
                <p className="text-4xl font-extrabold text-blue-300">500+</p>
                <p className="text-sm font-medium mt-1 text-gray-200">SCI & Scopus Papers Published</p>
              </div>
              <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm">
                <p className="text-4xl font-extrabold text-blue-300">98.4%</p>
                <p className="text-sm font-medium mt-1 text-gray-200">Journal Acceptance Rate</p>
              </div>
              <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm">
                <p className="text-4xl font-extrabold text-blue-300">14 Days</p>
                <p className="text-sm font-medium mt-1 text-gray-200">Average Turnaround</p>
              </div>
            </div>
          </div> */}

          {/* Research Services Comparison Table */}
          {/* <div className="mt-16 bg-white rounded-2xl p-6 md:p-8 shadow-xl">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center">
              Research Service Offerings Comparison
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse min-w-[600px]">
                <thead>
                  <tr className="bg-gray-100 text-gray-800 uppercase text-xs font-bold border-b border-gray-200">
                    <th className="py-3 px-4">Service Type</th>
                    <th className="py-3 px-4">Key Scope & Deliverables</th>
                    <th className="py-3 px-4">Tools & Software</th>
                    <th className="py-3 px-4">Target Audience</th>
                    <th className="py-3 px-4">Typical Timeline</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 text-sm text-gray-700">
                  <tr className="hover:bg-gray-50">
                    <td className="py-3 px-4 font-semibold text-blue-900">Thesis Writing Services</td>
                    <td className="py-3 px-4">Topic selection, literature review, chapter drafting, plagiarism check, formatting</td>
                    <td className="py-3 px-4">MATLAB, ANSYS, Python, SPSS, LaTeX</td>
                    <td className="py-3 px-4">PhD & M.Tech Scholars in Bhopal & India</td>
                    <td className="py-3 px-4">4 - 12 Weeks</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="py-3 px-4 font-semibold text-blue-900">SCI Paper Publication</td>
                    <td className="py-3 px-4">Novelty identification, manuscript drafting, IEEE/Springer formatting, peer response</td>
                    <td className="py-3 px-4">iThenticate, OriginPro, LaTeX, EndNote</td>
                    <td className="py-3 px-4">Academic Faculty & Researchers</td>
                    <td className="py-3 px-4">Journal Review Dependent</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="py-3 px-4 font-semibold text-blue-900">Scopus Paper Publication</td>
                    <td className="py-3 px-4">Target journal selection, editing, plagiarism clearance, submission support</td>
                    <td className="py-3 px-4">Grammarly Premium, Mendeley, Python</td>
                    <td className="py-3 px-4">Postgraduate & PhD Candidates</td>
                    <td className="py-3 px-4">2 - 8 Weeks</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="py-3 px-4 font-semibold text-blue-900">Simulation & Modeling</td>
                    <td className="py-3 px-4">Algorithm implementation, FEA analysis, statistical data validation, custom plots</td>
                    <td className="py-3 px-4">MATLAB, ANSYS, ETABS, STAAD.Pro, Minitab</td>
                    <td className="py-3 px-4">Engineering & Science Researchers</td>
                    <td className="py-3 px-4">1 - 3 Weeks</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> */}
        </div>
      </div>
    );
  }

  // Interactive Flipbook View
  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 flex items-center justify-center p-4 py-12">
      <div className="max-w-4xl w-full">
        {/* Header */}
        <div className="text-center mb-8">
          {/* <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Interactive Research Services Guide
          </h1> */}
          <button
            onClick={() => setViewMode('cards')}
            className="px-4 py-2 bg-white/20 text-white rounded-lg hover:bg-white/30 transition-all backdrop-blur-sm"
          >
            ← Back to Card View
          </button>
        </div>

        {/* Book Container */}
        <div className="relative mx-auto bg-gray-800 rounded-2xl shadow-2xl p-6 md:p-8 max-w-2xl">
          {/* Auto-flip progress bar */}
          {isAutoFlipping && (
            <div className="w-full bg-gray-700 rounded-full h-1.5 mb-6">
              <div 
                className="bg-blue-500 h-1.5 rounded-full transition-all duration-100"
                style={{ width: `${progress}%` }}
                ref={progressRef}
              ></div>
            </div>
          )}

          {/* Current Service Display */}
          <div className="bg-white rounded-xl overflow-hidden shadow-xl">
            <div className="relative h-64 md:h-80">
              <img
                src={pages[currentIndex].image}
                alt={`${pages[currentIndex].title} - Assurance Education Group Bhopal`}
                className="w-full h-full object-cover"
              />
              
              {/* Status Badge */}
              <div className="absolute top-4 right-4">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold shadow-lg ${
                  pages[currentIndex].checked 
                    ? 'bg-green-500 text-white' 
                    : 'bg-white text-gray-700'
                }`}>
                  {pages[currentIndex].checked ? '✓' : currentIndex + 1}
                </div>
              </div>

              {/* Content Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex items-end p-6">
                <div className="text-white w-full">
                  <span className="text-xs font-semibold text-blue-300 uppercase tracking-wide block mb-2">
                    {pages[currentIndex].subtitle}
                  </span>
                  <h2 className="text-2xl md:text-3xl font-bold mb-3">
                    {pages[currentIndex].title}
                  </h2>
                </div>
              </div>
            </div>

            {/* Service Details */}
            <div className="p-6 md:p-8">
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                {pages[currentIndex].content}
              </p>

              {/* Features List */}
              <div className="mb-6">
                <h4 className="font-semibold text-gray-900 mb-3">Key Features:</h4>
                <div className="grid grid-cols-2 gap-2">
                  {pages[currentIndex].features.slice(0, 4).map((feature, i) => (
                    <div key={i} className="flex items-center text-sm text-gray-600">
                      <span className="text-green-500 mr-2">•</span>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>

              {/* Progress Bar */}
              <div className="bg-gray-100 rounded-lg p-4">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-gray-700">Research Progress</span>
                  <span className="text-sm text-gray-600">{currentIndex + 1} of {total}</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div 
                    className="bg-gradient-to-r from-blue-500 to-blue-700 h-2 rounded-full transition-all duration-500" 
                    style={{width: `${((currentIndex + 1) / total) * 100}%`}}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Controls */}
          <div className="flex justify-between items-center mt-6 px-2 flex-wrap gap-4">
            <button 
              onClick={prev}
              className="flex items-center gap-2 px-4 py-3 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-all backdrop-blur-sm"
            >
              ← Previous
            </button>

            <div className="flex items-center gap-4">
              <span className="text-white/80 text-sm">
                {currentIndex + 1} / {total}
              </span>
              
              <button 
                onClick={toggleAutoFlip}
                className={`px-4 py-2 rounded-lg transition-all ${
                  isAutoFlipping 
                    ? 'bg-green-500 text-white' 
                    : 'bg-white/10 text-white hover:bg-white/20'
                } backdrop-blur-sm`}
              >
                {isAutoFlipping ? '⏸ Pause' : '▶ Auto Flip'}
              </button>
            </div>

            <button 
              onClick={next}
              className="flex items-center gap-2 px-4 py-3 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-all backdrop-blur-sm"
            >
              Next →
            </button>
          </div>

          {/* Dot Navigation */}
          <div className="flex justify-center gap-2 mt-6">
            {pages.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2 h-2 rounded-full transition-all duration-200 ${
                  index === currentIndex 
                    ? 'bg-white scale-150' 
                    : 'bg-white/40 hover:bg-white/70'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;